import React, { RefCallback } from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { ColorValueStrict } from 'fronton-react';

export type LinkProps = {
  className?: string;
  children: React.ReactNode;
  refCb?: RefCallback<HTMLAnchorElement>;
  title: string;
  bgcolor?: ColorValueStrict | string;
  hoverbgcolor?: ColorValueStrict | string;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const Link: React.FC<LinkProps> = ({ children, className, refCb, ...rest }) => (
  <a
    className={cn(linkStyle, className)}
    data-testid="link"
    {...(rest as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
    ref={refCb}>
    {children}
  </a>
);

export const linkStyle = css`
  display: block;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    text-decoration: none;
  }

  &:hover {
    text-decoration: none;
  }
`;
